<template>
  <div>

    <sweet-modal blocking :title="$t('vendors_editVendor')" ref="editVendorForm" class="modal" v-on:close="closeModal">

      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">

        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('modal_title_general')" name="general">

            <!-- General -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_general')}}</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="name">
                    <!-- <el-input v-model="form.name" size="mini" :label="$t('modal_full_name')"></el-input> -->
                    <el-autocomplete
                      style="width: 100%;"
                      :label="$t('modal_full_name')"
                      :fetch-suggestions="querySearch"
                      value-key="name"
                      v-model="form.name">
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="shortName">
                    <el-input v-model="form.shortName" size="mini" :label="$t('modal_short_name')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="email">
                    <el-input v-model="form.email" size="mini" :label="$t('modal_email')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="website">
                    <el-input v-model="form.website" size="mini" :label="$t('modal_website')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="phone">
                    <el-input v-model="form.phone" size="mini" :label="$t('modal_phone_main')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="fax">
                    <el-input v-model="form.fax" size="mini" :label="$t('modal_fax_main')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="facebook">
                    <el-input v-model="form.facebook" size="mini" :label="$t('modal_facebook')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="linkedIn">
                    <el-input v-model="form.linkedIn" size="mini" :label="$t('modal_linkedIn')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="managerId" v-if="directories">
                    <el-select v-model="form.managerId" size="mini" :placeholder="$t('modal_assign_supply_chain_mgr')" clearable filterable style="width: 100%;">
                      <el-option v-for="item in directories.managerList"
                        :key="item.id"
                        :label="item.fullName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="shippingMethodId" v-if="directories">
                    <el-select v-model="form.shippingMethodId" size="mini" :placeholder="$t('modal_shipping_method')" clearable filterable style="width: 100%;">
                      <el-option v-for="item in directories.shippingMethod"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="tagAs">
                    <el-input v-model="form.tagAs" size="mini" label="Tag As"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
              </el-row>
            </el-card>

          </el-tab-pane>
          <el-tab-pane :label="$t('modal_title_addresses')" name="addresses">

            <!-- Addresses -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_addresses')}}</h3>

              <h4>Main Address:</h4>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="mainAddress">
                    <el-input v-model="form.mainAddress" @blur="form.mainAddress = form.mainAddress.trim()" size="mini" :label="$t('modal_address_line_1')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="mainCountryId">
                    <el-select no-data-text="no data" v-model="form.mainCountryId" @visible-change="loadMainCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                      <el-option
                        v-for="item in mainCountryList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="setState('main', item)">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="mainAddress2">
                    <el-input v-model="form.mainAddress2" @blur="form.mainAddress2 = form.mainAddress2.trim()" size="mini" :label="$t('modal_address_line_2')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="mainStateId">
                    <el-select no-data-text="no data" v-model="form.mainStateId" @visible-change="loadMainStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                      <el-option
                        v-for="item in mainStateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        @click.native="setCity('main', item)">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="mainAddress3">
                    <el-input v-model="form.mainAddress3" @blur="form.mainAddress3 = form.mainAddress3.trim()" size="mini" :label="$t('modal_address_line_3')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="mainCityId">
                    <el-select no-data-text="no data" v-model="form.mainCityId" @visible-change="loadMainCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                      <el-option
                        v-for="item in mainCityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <br/>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="mainPostCode">
                    <el-input v-model="form.mainPostCode" @blur="form.mainPostCode = form.mainPostCode.trim()" size="mini" :label="$t('modal_post_code')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- TODO: address -->
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="billingCopyMainAddress">
                    <el-checkbox v-model="form.billingCopyMainAddress" size="mini">Copy Main Address to Invoicing Address</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="swCopyMainAddress">
                    <el-checkbox v-model="form.swCopyMainAddress" size="mini">Copy Main Address to Delivery Address</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>

              <template v-if="!form.billingCopyMainAddress">
                <h4>Billing Address:</h4>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="billingAddress">
                      <el-input v-model="form.billingAddress" size="mini" :label="$t('modal_address_line_1')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="billingCountryId">
                      <el-select no-data-text="no data" v-model="form.billingCountryId" @visible-change="loadBillingCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in billingCountryList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setState('billing', item)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="billingAddress2">
                      <el-input v-model="form.billingAddress2" size="mini" :label="$t('modal_address_line_2')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="billingStateId">
                      <el-select no-data-text="no data" v-model="form.billingStateId" @visible-change="loadBillingStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in billingStateList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setCity('billing', item)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="billingAddress3">
                      <el-input v-model="form.billingAddress3" size="mini" :label="$t('modal_address_line_3')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="billingCityId">
                      <el-select no-data-text="no data" v-model="form.billingCityId" @visible-change="loadBillingCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in billingCityList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <br/>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="billingPostCode">
                      <el-input v-model="form.billingPostCode" size="mini" :label="$t('modal_post_code')"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <template v-if="!form.swCopyMainAddress">
                <h4>Shipping/Warehouse Address:</h4>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="swAddress">
                      <el-input v-model="form.swAddress" size="mini" :label="$t('modal_address_line_1')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="swCountryId">
                      <el-select no-data-text="no data" v-model="form.swCountryId" @visible-change="loadSWCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in swCountryList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setState('sw', item)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="swAddress2">
                      <el-input v-model="form.swAddress2" size="mini" :label="$t('modal_address_line_2')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="swStateId">
                      <el-select no-data-text="no data" v-model="form.swStateId" @visible-change="loadSWStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in swStateList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setCity('sw', item)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="swAddress3">
                      <el-input v-model="form.swAddress3" size="mini" :label="$t('modal_address_line_3')"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="swCityId">
                      <el-select no-data-text="no data" v-model="form.swCityId" @visible-change="loadSWCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                        <el-option
                          v-for="item in swCityList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <br/>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="swPostCode">
                      <el-input v-model="form.swPostCode" size="mini" :label="$t('modal_post_code')"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <el-button type="primary" size="default" @click="openBranchOfficeTable">Branch Office Table</el-button>

            </el-card>

          </el-tab-pane>
          <el-tab-pane :label="$t('modal_title_finance')" name="finance">

            <!-- Finance -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_finance')}}</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <h4>{{$t('modal_title_general')}}</h4>
                </el-col>
                <el-col :span="12">
                  <h4>Bank Details</h4>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12" :offset="0">

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="currencyId" v-if="directories">
                        <el-select v-model="form.currencyId" size="mini" :placeholder="$t('modal_currency')" style="width: 100%;" filterable>
                          <el-option v-for="item in directories.currenciesList"
                            :key="item.id"
                            :label="item.code"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="creditLimit">
                        <money v-model="form.creditLimit" v-bind="money"></money>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="paymentTermsId" v-if="directories">
                        <el-select v-model="form.paymentTermsId" size="mini" :placeholder="$t('modal_payment_terms')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.paymentTermsList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="paymentTypesId" v-if="directories">
                        <el-select v-model="form.paymentTypesId" size="mini" :placeholder="$t('modal_payment_types')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.paymentTypesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </el-col>
                <el-col :span="12" :offset="0">

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="bankName">
                        <el-input v-model="form.bankName" size="mini" :label="$t('modal_bank_name')"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="bankAddressAssign">
                        <el-switch v-model="form.bankAddressAssign" :active-text="$t('modal_bank_address')"></el-switch>
                      </el-form-item>
                    </el-col>

                    <template v-if="form.bankAddressAssign">
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankAddress">
                          <el-input v-model="form.bankAddress" size="mini" :label="$t('modal_address_line_1')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankAddress2">
                          <el-input v-model="form.bankAddress2" size="mini" :label="$t('modal_address_line_2')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankAddress3">
                          <el-input v-model="form.bankAddress3" size="mini" :label="$t('modal_address_line_3')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankCityId">
                          <el-select no-data-text="no data" v-model="form.bankCityId" @visible-change="loadBankCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
                            <el-option
                              v-for="item in bankCityList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankStateId">
                          <el-select no-data-text="no data" v-model="form.bankStateId" @visible-change="loadBankStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
                            <el-option
                              v-for="item in bankStateList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              @click.native="setCity('bank', item)">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankPostCode">
                          <el-input v-model="form.bankPostCode" size="mini" :label="$t('modal_post_code')"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0">
                        <el-form-item prop="bankCountryId">
                          <el-select no-data-text="no data" v-model="form.bankCountryId" @visible-change="loadBankCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
                            <el-option
                              v-for="item in bankCountryList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              @click.native="setState('bank', item)">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :offset="0"></el-col>
                    </template>

                    <el-col :span="24" :offset="0">
                      <el-form-item prop="SWIFTCode">
                        <el-input v-model="form.SWIFTCode" size="mini" :label="$t('modal_SWIFT_code')"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="accountName">
                        <el-input v-model="form.accountName" size="mini" :label="$t('modal_account_name')"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="branchSortCode">
                        <el-input v-model="form.branchSortCode" size="mini" :label="$t('modal_account_branch')"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="accountIBANNo">
                        <el-input v-model="form.accountIBANNo" size="mini" :label="$t('modal_account_account')"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </el-col>
              </el-row>

            </el-card>

          </el-tab-pane>
          <el-tab-pane :label="$t('modal_title_canvass')" name="canvass">

            <!-- Canvass -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_canvass')}}</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="ISOAccreditationNo">
                    <el-input v-model="form.ISOAccreditationNo" size="mini" :label="$t('modal_iso')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="canvassSheetId">
                    <el-input v-model="form.canvassSheetId" size="mini" :label="$t('modal_canvass_sheet')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="formsId">
                    <el-input v-model="form.formsId" size="mini" :label="$t('modal_forms')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">

                </el-col>
              </el-row>

            </el-card>

          </el-tab-pane>
          <el-tab-pane :label="$t('modal_title_custom')" name="custom">

            <!-- Custom -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_custom')}}</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="customField1">
                    <el-input v-model="form.customField1" size="mini" :label="$t('modal_custom_field_1')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="customField2">
                    <el-input v-model="form.customField2" size="mini" :label="$t('modal_custom_field_2')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="customField3">
                    <el-input v-model="form.customField3" size="mini" :label="$t('modal_custom_field_3')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="customField4">
                    <el-input v-model="form.customField4" size="mini" :label="$t('modal_custom_field_4')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="customField5">
                    <el-input v-model="form.customField5" size="mini" :label="$t('modal_custom_field_5')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="customField6">
                    <el-input v-model="form.customField6" size="mini" :label="$t('modal_custom_field_6')"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-card>

          </el-tab-pane>
          <el-tab-pane label="Tax Settings" name="settings">

            <!-- Tax Settings -->
            <el-card shadow="never" style="margin-bottom: 20px;">

              <h3>Tax Settings</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item prop="companyTypeId" v-if="directories">
                        <el-select v-model="form.companyTypeId" size="mini" :placeholder="$t('modal_product_or_service')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.serviceTypesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="changeCompanyTypeId()">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="saleTaxId" v-if="directories">
                        <el-tooltip content="See Certificate of Registration for this Vendor" placement="top">
                          <el-select v-model="form.saleTaxId" size="mini" :placeholder="$t('modal_tax_type_vat')" clearable filterable style="width: 100%;">
                            <el-option v-for="item in directories.inputTaxSubAccounts"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              @click.native="setTaxCode('taxCode', item)">
                            </el-option>
                          </el-select>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="taxCode">
                        <el-input disabled v-model="form.taxCode" size="mini" label="Tax Code (VAT)"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="form.companyTypeId">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="applyWithholdingTax">
                        <el-switch v-model="form.applyWithholdingTax" active-text="Apply Withholding Tax Expanded"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="(form.companyTypeId === 2 || form.companyTypeId === 3) && form.applyWithholdingTax">
                    <el-col :span="24">
                      <el-form-item prop="productWithholdingTaxId" v-if="directories">
                        <el-select v-model="form.productWithholdingTaxId" size="mini" placeholder="Tax Type (WHT) Product" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.withholdingTaxExpanded"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setTaxCode('taxCodeProduct', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="(form.companyTypeId === 2 || form.companyTypeId === 3) && form.applyWithholdingTax">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="taxCodeProduct">
                        <el-input disabled v-model="form.taxCodeProduct" size="mini" label="Tax Code (WHT) Product"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="(form.companyTypeId === 1 || form.companyTypeId === 3) && form.applyWithholdingTax">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="serviceWithholdingTaxId" v-if="directories">
                        <el-select v-model="form.serviceWithholdingTaxId" size="mini" placeholder="Tax Type (WHT) Service" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.withholdingTaxExpanded"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setTaxCode('taxCodeService', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row v-if="(form.companyTypeId === 1 || form.companyTypeId === 3) && form.applyWithholdingTax">
                    <el-col :span="24" :offset="0">
                      <el-form-item prop="taxCodeService">
                        <el-input disabled v-model="form.taxCodeService" size="mini" label="Tax Code (WHT) Service"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-row>
                    <el-col :span="24" :offset="0">
                      <div class="vat-block">
                        <el-form-item style="margin-bottom: 15px;">
                          <h4 class="vat-block__title">Withhold Expanded VAT</h4>
                          <i @click="() => this.$refs['infoModal'].openModal()" class="vat-block__icon el-icon-question"></i>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 15px;" prop="clientWithholding">
                          <el-switch v-model="form.clientWithholding" active-text="I Withhold Expanded VAT from this Vendor"></el-switch>
                        </el-form-item>

                        <el-form-item prop="clientWithholdingTaxId" v-if="this.form.clientWithholding && directories">
                          <el-select v-model="form.clientWithholdingTaxId" size="mini" :placeholder="$t('modal_tax_type_vat')" clearable filterable style="width: 100%;">
                            <el-option v-for="item in directories.creditableVatWithheldSubAccounts"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                              @click.native="setTaxCode('taxCodeClientWithholding', item)">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item v-if="this.form.clientWithholding" prop="taxCodeClientWithholding">
                          <el-input disabled v-model="form.taxCodeClientWithholding" size="mini" :label="$t('modal_tax_code_vat')"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

            </el-card>

          </el-tab-pane>
          <el-tab-pane :label="$t('modal_title_expanded')" name="expanded">

            <el-card shadow="never" style="margin-bottom: 20px;">
              <el-form-item prop="enableExpanded" style="margin-bottom: 0px;">
                <el-switch v-model="form.enableExpanded" active-text="Activate Expanded Details"></el-switch>
              </el-form-item>
            </el-card>

            <!-- Expanded -->
            <el-card v-if="form.enableExpanded" shadow="never" style="margin-bottom: 20px;">

              <h3>{{$t('modal_title_expanded')}}</h3>

              <el-row :gutter="20">
                <el-col :span="12">
                  <h4>{{$t('modal_title_general')}}</h4>
                </el-col>
                <el-col :span="12">
                  <h4>Tax & Compliance (BIR)</h4>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12" :offset="0">

                  <el-row>
                    <el-col :span="24">
                      <el-form-item prop="expandedCountryId" v-if="directories">
                        <el-select v-model="form.expandedCountryId" size="mini" :placeholder="$t('modal_country')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.countryList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="registrationBodyId">
                        <el-select v-model="form.registrationBodyId" size="mini" placeholder="Registration Body" filterable style="width: 100%;">
                          <el-option v-for="item in registrationBodyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="industryTypeId" v-if="directories">
                        <el-select v-model="form.industryTypeId" size="mini" placeholder="Industry Type" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.industryTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="categoryOfClientId" v-if="directories">
                        <el-select v-model="form.categoryOfClientId" size="mini" placeholder="Category Of Client" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.categoryOfClientList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="companyName" v-if="form.registrationBodyId !== 1">
                        <el-input v-model="form.companyName" size="mini" label="Company"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.registrationBodyId === 1">
                      <el-form-item prop="firstName">
                        <el-input v-model="form.firstName" size="mini" label="First Name"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.registrationBodyId === 1">
                      <el-form-item prop="middleName">
                        <el-input v-model="form.middleName" size="mini" label="Middle Name"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.registrationBodyId === 1">
                      <el-form-item prop="surname">
                        <el-input v-model="form.surname" size="mini" label="Surname"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="tradeName">
                        <el-input v-model="form.tradeName" size="mini" label="Trade Name"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.registrationBodyId === 1">
                      <el-form-item prop="osca">
                        <el-input v-model="form.osca" size="mini" label="Office for Senior Citizens Affairs (OSCA)"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.registrationBodyId === 1">
                      <el-form-item prop="pwd">
                        <el-input v-model="form.pwd" size="mini" label="Person with Disabilities (PWD)"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="registrationSECNo">
                        <el-input v-model="form.registrationSECNo" size="mini" label="Registration No."></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="rdoId" v-if="directories">
                        <el-select v-model="form.rdoId" size="mini" placeholder="RDO" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.rdoList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="barangay">
                        <el-input v-model="form.barangay" size="mini" label="Barangay"></el-input>
                      </el-form-item>
                    </el-col>

                  </el-row>

                </el-col>
                <el-col :span="12" :offset="0">

                  <el-row>
                    <el-col :span="24">
                      <el-form-item>
                        Certifcate of Registration
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item>
                        <div v-if="file">
                          <div class="file-row">
                            <span @click="viewFile(file.url, file, -1, false)" class="file-row__file-name">{{ file.name }}</span>
                            <el-button
                                size="mini"
                                type="danger"
                                plain
                                icon="el-icon-delete"
                                @click="removeFile(file, 76)"></el-button>
                          </div>
                        </div>
                        <el-button v-else style="width:100%" @click="() => $refs.fileVendor.click()">
                          Upload Certificate of Registration
                        </el-button>
                        <input ref='fileVendor' v-show="false" @change="handleFile" type="file">
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="taxClassificationId" v-if="directories">
                        <el-select v-model="form.taxClassificationId" size="mini" :placeholder="$t('modal_tax_classification')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.taxClassificationList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" :offset="0">
                      <el-form-item prop="radio">
                        <el-radio-group v-model="form.radio">
                          <el-radio :label="1">Line of Business (PSIC)</el-radio>
                          <el-radio :label="2">Occupation (PSOC)</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="form.radio === 1">
                      <el-form-item prop="lineOfBusinessId" v-if="directories">
                        <el-select v-model="form.lineOfBusinessId" size="mini" placeholder="Line of Business (PSIC)" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.linesOfBusinessList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" v-else>
                      <el-form-item prop="occupationId" v-if="directories">
                        <el-select v-model="form.occupationId" size="mini" placeholder="Occupation (PSOC)" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.occupationList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="taxIdentificationNo">
                        <el-input v-model="form.taxIdentificationNo" v-mask="'###-###-###-#####'" size="mini" :label="$t('modal_tin')"></el-input>
                      </el-form-item>
                    </el-col>

                    <!-- <el-col :span="24" v-if="this.form.clientWithholding">
                      <el-form-item prop="clientWithholdingTaxId" v-if="directories">
                        <el-select v-model="form.clientWithholdingTaxId" size="mini" :placeholder="$t('modal_tax_type_vat')" clearable filterable style="width: 100%;">
                          <el-option v-for="item in directories.creditableVatWithheldSubAccounts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setTaxCode('taxCodeClientWithholding', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col> -->

                    <!-- <el-col :span="24" v-if="this.form.clientWithholding">
                      <el-form-item prop="taxCodeClientWithholding">
                        <el-input disabled v-model="form.taxCodeClientWithholding" size="mini" :label="$t('modal_tax_code_vat')"></el-input>
                      </el-form-item>
                    </el-col> -->
                  </el-row>

                </el-col>
              </el-row>

            </el-card>

          </el-tab-pane>
        </el-tabs>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('editVendorForm')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <sweet-modal width="1000" blocking title="Branch Office List" ref="modalBranchOfficeList" v-on:close="closeModalBranchOfficeList">
      <el-form :model="form" size="mini" ref="formBranchOfficeList" status-icon>

        <el-table
          size="mini"
          border
          max-height="400"
          :data="form.branchOfficeList"
          style="width: 100%">
          <el-table-column
            width="120"
            label="TIN Code">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-input placeholder="TIN Code" v-model="scope.row.TINCode" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="TF BU">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }"
                :prop="'branchOfficeList.' + scope.$index + '.buId'">
                <el-select style="width: 100%" v-model="scope.row.buId" filterable clearable placeholder="Regional District Office">

                  <el-option v-for="item in directories.buList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>

                </el-select>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="120"
            label="Address Line 1">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-input placeholder="Address Line 1" v-model="scope.row.addressLine1" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="120"
            label="Address Line 2">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-input placeholder="Address Line 2" v-model="scope.row.addressLine2" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="120"
            label="Address Line 3">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-input placeholder="Address Line 3" v-model="scope.row.addressLine3" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            label="City">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-select
                    no-data-text="no data"
                    :disabled="!scope.row.stateId"
                    v-model="scope.row.cityId"
                    filterable>
                  <el-option
                      v-for="item in scope.row.cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="180"
            label="State / Province / Country">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-select
                    no-data-text="no data"
                    :disabled="!scope.row.countryId"
                    v-model="scope.row.stateId"
                    filterable
                    @change="changeState(scope.row)">
                  <el-option
                      v-for="item in scope.row.stateList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="120"
            label="Post Code">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-input placeholder="Post Code" v-model="scope.row.postCode" size="mini"></el-input>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            label="Country">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;">
                <el-select
                  no-data-text="no data"
                  v-model="scope.row.countryId"
                  @visible-change="loadCountryList($event, scope.row)"
                  @change="changeCountry(scope.row)"
                  filterable>
                  <el-option
                    v-for="item in scope.row.countryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>

          <el-table-column
            width="160"
            label="Regional District Office">
            <template slot-scope="scope">
              <el-form-item style="margin-bottom:0;"
                :rules="{ required: true, message: 'Field is required', trigger: 'blur' }"
                :prop="'branchOfficeList.' + scope.$index + '.rdoId'">
                <el-select style="width: 100%" v-model="scope.row.rdoId" filterable clearable placeholder="Regional District Office">

                  <el-option v-for="item in directories.rdoList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>

                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            align="center"
            width="67">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  @click.native.prevent="deleteRow(scope.$index, form.branchOfficeList)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item style="display: flex; justify-content: flex-end; padding-top: 20px;">
          <el-button plain size="medium" @click="addNewItem">Add line</el-button>
          <el-button @click="modalBranchOfficeListSubmit('formBranchOfficeList')" type="primary" plain size="medium">Save</el-button>
        </el-form-item>

      </el-form>
    </sweet-modal>

    <info-modal ref="infoModal" title="Withhold Expanded VAT">
      I am a Government or Government Controlled Corporation & withhold a percentage of the VAT payable to this vendor.
    </info-modal>

    <div v-if="viewerType == 1">
      <sweet-modal v-if="viewerType == 1" ref="nestedChild">
        <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
      </sweet-modal>
    </div>
    <div v-if="viewerType == 2">
      <div v-show="false" class="images" v-viewer="getViewerSettings">
        <img :src="fileUrl" :key="fileUrl" />
      </div>
    </div>
    <div class="mod" v-if="viewerType == 3">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
        :kind="'video'"
        :controls="true"
        :src="fileUrl"
      >
      </Media>
    </div>
    <div class="mod" v-if="viewerType == 4">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
        :kind="'audio'"
        :controls="true"
        :src="fileUrl"
      >
      </Media>
    </div>

  </div>
</template>

<script>
import InfoModal from '@/components/InfoModal.vue'
import { mapGetters } from 'vuex'
import { viewEditFileMixin } from '../../mixins/viewEditFileMixin'
import { linkFormatting } from '../../mixins/linkFormatting'
import Media from '@dongido/vue-viaudio'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
import {Money} from 'v-money'
export default {
  components: {
    SweetModal,
    Money,
    Media,
    InfoModal,
  },
  props: ['editVendorForm', 'directories', 'companyVendorsItem'],
  mixins: [viewEditFileMixin, linkFormatting],
  computed: {
    ...mapGetters([
      'getViewerSettings'
    ]),
  },
  watch: {
    companyVendorsItem: function (val) {
      this.form.id = val.id
      this.getFiles()

      this.form.enableExpanded = val.enableExpanded

      this.form.name = val.name
      this.form.shortName = val.shortName
      this.form.email = val.email
      this.form.website = val.website
      this.form.linkedIn = val.linkedIn
      this.form.facebook = val.facebook
      this.form.phone = val.phone
      this.form.fax = val.fax
      this.form.managerId = val.managerId
      this.form.shippingMethodId = val.shippingMethodId
      this.form.tagAs = val.tagAs || null

      // Address
      this.mainCountryList.push(val.addresses.mainAddress.country)
      this.mainStateList.push(val.addresses.mainAddress.state)
      this.mainCityList.push(val.addresses.mainAddress.city)
      this.form.mainCountryId = val.addresses.mainAddress.countryId
      this.form.mainStateId = val.addresses.mainAddress.stateId
      this.form.mainCityId = val.addresses.mainAddress.cityId
      this.form.mainPostCode = val.addresses.mainAddress.postCode
      this.form.mainAddress = val.addresses.mainAddress.addressLines.addressLine1
      this.form.mainAddress2 = val.addresses.mainAddress.addressLines.addressLine2
      this.form.mainAddress3 = val.addresses.mainAddress.addressLines.addressLine3

      this.form.billingCopyMainAddress = val.addresses.billingAddress.copyMainAddress
      this.billingCountryList.push(val.addresses.billingAddress.country)
      this.billingStateList.push(val.addresses.billingAddress.state)
      this.billingCityList.push(val.addresses.billingAddress.city)
      this.form.billingCountryId = val.addresses.billingAddress.countryId
      this.form.billingStateId = val.addresses.billingAddress.stateId
      this.form.billingCityId = val.addresses.billingAddress.cityId
      this.form.billingPostCode = val.addresses.billingAddress.postCode
      this.form.billingAddress = val.addresses.billingAddress.addressLines.addressLine1
      this.form.billingAddress2 = val.addresses.billingAddress.addressLines.addressLine2
      this.form.billingAddress3 = val.addresses.billingAddress.addressLines.addressLine3

      this.form.swCopyMainAddress = val.addresses.shippingWarehouseAddress.copyMainAddress
      this.swCountryList.push(val.addresses.shippingWarehouseAddress.country)
      this.swStateList.push(val.addresses.shippingWarehouseAddress.state)
      this.swCityList.push(val.addresses.shippingWarehouseAddress.city)
      this.form.swCountryId = val.addresses.shippingWarehouseAddress.countryId
      this.form.swStateId = val.addresses.shippingWarehouseAddress.stateId
      this.form.swCityId = val.addresses.shippingWarehouseAddress.cityId
      this.form.swPostCode = val.addresses.shippingWarehouseAddress.postCode
      this.form.swAddress = val.addresses.shippingWarehouseAddress.addressLines.addressLine1
      this.form.swAddress2 = val.addresses.shippingWarehouseAddress.addressLines.addressLine2
      this.form.swAddress3 = val.addresses.shippingWarehouseAddress.addressLines.addressLine3

      this.form.branchOfficeList = val.addresses.branchOfficeList ? val.addresses.branchOfficeList.map(val => ({
        TINCode: val.TINCode,
        buId: val.buId,
        countryId: val.country ? val.country.id : null,
        postCode: val.postCode,
        stateId: val.state ? val.state.id : null,
        cityId: val.city ? val.city.id : null,
        addressLine1: val.addressLine1,
        addressLine2: val.addressLine2,
        addressLine3: val.addressLine3,
        rdoId: val.rdoId,
        //
        countryList: val.country ? [val.country] : [],
        stateList: val.state ? [val.state] : [],
        cityList: val.city ? [val.city] : []
      })) : []

      // Finance
      this.form.currencyId = val.finance.currencyId
      this.form.creditLimit = +val.finance.creditLimit
      this.form.paymentTermsId = val.finance.paymentTermsId
      this.form.paymentTypesId = val.finance.paymentTypesId
      this.form.bankName = val.finance.bankName

      this.form.bankAddressAssign = val.finance.bankAddressAssign
      if (val.finance.bankAddressAssign) {
        this.bankCountryList.push(val.addresses.bankAddress.country)
        this.bankStateList.push(val.addresses.bankAddress.state)
        this.bankCityList.push(val.addresses.bankAddress.city)
        this.form.bankCountryId = val.addresses.bankAddress.countryId
        this.form.bankStateId = val.addresses.bankAddress.stateId
        this.form.bankCityId = val.addresses.bankAddress.cityId
        this.form.bankPostCode = val.addresses.bankAddress.postCode
        this.form.bankAddress = val.addresses.bankAddress.addressLines.addressLine1
        this.form.bankAddress2 = val.addresses.bankAddress.addressLines.addressLine2
        this.form.bankAddress3 = val.addresses.bankAddress.addressLines.addressLine3
      }

      this.form.SWIFTCode = val.finance.SWIFTCode
      this.form.accountName = val.finance.accountName
      this.form.branchSortCode = val.finance.branchSortCode
      this.form.accountIBANNo = val.finance.accountIBANNo

      // Canvass
      this.form.ISOAccreditationNo = val.canvas.ISOAccreditationNo
      this.form.canvassSheetId = val.canvas.canvassSheetId
      this.form.formsId = val.canvas.formsId

      // Custom
      this.form.customField1 = val.custom.customField1
      this.form.customField2 = val.custom.customField2
      this.form.customField3 = val.custom.customField3
      this.form.customField4 = val.custom.customField4
      this.form.customField5 = val.custom.customField5
      this.form.customField6 = val.custom.customField6

      // Tax Settings
      if (val.tax) {
        this.form.companyTypeId = val.tax.companyTypeId
        this.form.saleTaxId = val.tax.saleTaxId || null
        if (val.tax.saleTaxId) {
          this.form.taxCode = val.tax.saleTax.tax.code || null
        }

        this.form.clientWithholding = val.tax.clientWithholding || false
        this.form.clientWithholdingTaxId = val.tax.clientWithholdingTaxId || null
        if (val.tax.clientWithholdingTaxId) {
          this.form.taxCodeClientWithholding = val.tax.clientWithholdingTax.tax.code || null
        }

        if (val.tax.productWithholdingTaxId || val.tax.serviceWithholdingTaxId) {
          this.form.applyWithholdingTax = true
        } else {
          this.form.applyWithholdingTax = false
        }
        this.form.productWithholdingTaxId = val.tax.productWithholdingTaxId || null
        this.form.serviceWithholdingTaxId = val.tax.serviceWithholdingTaxId || null
        if (val.tax.productWithholdingTaxId) {
          this.form.taxCodeProduct = val.tax.productWithholdingTax.tax.code || null
        }
        if (val.tax.serviceWithholdingTaxId) {
          this.form.taxCodeService = val.tax.serviceWithholdingTax.tax.code || null
        }
      }

      if (val.enableExpanded) {
        // Expanded
        this.form.registrationBodyId = val.expanded.general.registrationBodyId
        // --General
        this.form.expandedCountryId = val.expanded.general.countryId
        this.form.industryTypeId = val.expanded.general.industryTypeId,
        this.form.categoryOfClientId = val.expanded.general.categoryOfClientId,
        this.form.companyName = val.expanded.general.companyName,
        this.form.firstName = val.expanded.general.firstName,
        this.form.middleName = val.expanded.general.middleName,
        this.form.surname = val.expanded.general.surname,
        this.form.tradeName = val.expanded.general.tradeName,
        this.form.osca = val.expanded.general.osca,
        this.form.pwd = val.expanded.general.pwd,
        this.form.rdoId = val.expanded.general.rdoId,
        this.form.barangay = val.expanded.general.barangay,
        this.form.registrationSECNo = val.expanded.general.registrationSECNo
        // --Compliance
        this.form.taxClassificationId = val.expanded.compliance.taxClassificationId
        this.form.radio = val.expanded.compliance.occupationId ? 2 : 1
        this.form.lineOfBusinessId = val.expanded.compliance.lineOfBusinessId
        this.form.occupationId = val.expanded.compliance.occupationId
        this.form.taxIdentificationNo = val.expanded.compliance.taxIdentificationNo
      }
    },
    'form.applyWithholdingTax': function (newVal, oldVal) {
      this.form.productWithholdingTaxId = null
      this.form.taxCodeProduct = null
      this.form.serviceWithholdingTaxId = null
      this.form.taxCodeService = null
    },
    'form.taxTypeId': function (newVal, oldVal) {
      if (!newVal) { this.form.taxCode = null }
    },
    'form.applyWithholdingTaxProductId': function (newVal, oldVal) {
      if (!newVal) { this.form.taxCodeProduct = null }
    },
    'form.applyWithholdingTaxServiceId': function (newVal, oldVal) {
      if (!newVal) { this.form.taxCodeService = null }
    },
  },
  data() {
    return {
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        prefix: 'Credit Limit: ',
        masked: false
      },

      activeName: 'general',

      mainCountryList: [],
      mainStateList: [],
      mainCityList: [],

      billingCountryList: [],
      billingStateList: [],
      billingCityList: [],

      swCountryList: [],
      swStateList: [],
      swCityList: [],

      bankCountryList: [],
      bankStateList: [],
      bankCityList: [],

      registrationBodyList: [
        {id: 1, name: 'Department of Trade & Industry'},
        {id: 2, name: 'Security & Exchange Commission'},
        {id: 3, name: 'Cooperative Development Authority'}
      ],

      file: null,
      form: {
        enableExpanded: false,
        id: null,
        // General
        name: '',
        shortName: null,
        email: '',
        website: '',
        linkedIn: '',
        facebook: '',
        phone: '',
        fax: '',
        managerId: null,
        shippingMethodId: null,
        tagAs: null,

        // Address
        mainCountryId: null,
        mainStateId: null,
        mainCityId: null,
        mainPostCode: '',
        mainAddress: '',
        mainAddress2: '',
        mainAddress3: '',

        billingCopyMainAddress: true,
        billingCountryId: null,
        billingStateId: null,
        billingCityId: null,
        billingPostCode: '',
        billingAddress: '',
        billingAddress2: '',
        billingAddress3: '',

        swCopyMainAddress: true,
        swCountryId: null,
        swStateId: null,
        swCityId: null,
        swPostCode: '',
        swAddress: '',
        swAddress2: '',
        swAddress3: '',

        branchOfficeList: [],

        // Finance
        currencyId: null,
        creditLimit: null,
        paymentTermsId: null,
        paymentTypesId: null,
        bankName: null,

        bankAddressAssign: false,
        bankCountryId: null,
        bankStateId: null,
        bankCityId: null,
        bankPostCode: '',
        bankAddress: '',
        bankAddress2: '',
        bankAddress3: '',

        SWIFTCode: null,
        accountName: null,
        branchSortCode: null,
        accountIBANNo: null,

        // Canvass
        ISOAccreditationNo: null,
        canvassSheetId: null,
        formsId: null,

        // Custom
        customField1: null,
        customField2: null,
        customField3: null,
        customField4: null,
        customField5: null,
        customField6: null,

        // Tax Settings
        companyTypeId: null,
        saleTaxId: null,
        taxCode: null,
        clientWithholding: false,
        clientWithholdingTaxId: null,
        taxCodeClientWithholding: null,
        applyWithholdingTax: true,
        productWithholdingTaxId: null,
        serviceWithholdingTaxId: null,
        taxCodeProduct: null,
        taxCodeService: null,

        // Expanded
        registrationBodyId: 1,
        // --General
        expandedCountryId: null,
        industryTypeId: null,
        categoryOfClientId: null,
        companyName: null,
        firstName: null,
        middleName: null,
        surname: null,
        tradeName: null,
        osca: null,
        pwd: null,
        rdoId: null,
        barangay: null,
        registrationSECNo: null,
        // --Compliance
        taxClassificationId: null,
        radio: 1,
        lineOfBusinessId: null,
        occupationId: null,
        taxIdentificationNo: null,
      },
      rules: {
        // General
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Invalid email' }
        ],
        // Addresses
        mainCountryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        mainStateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        mainCityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        billingCountryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        billingStateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        billingCityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        swCountryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        swStateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        swCityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        // Finance
        bankCountryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        bankStateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        bankCityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        // Tax Settings
        companyTypeId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        productWithholdingTaxId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        serviceWithholdingTaxId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        saleTaxId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        clientWithholdingTaxId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        // Expanded
        taxClassificationId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        lineOfBusinessId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        occupationId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        taxIdentificationNo: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    querySearch(queryString, cb) {
      let links = this.directories.entityNameList
      let results = queryString ? links.filter(this.createFilter(queryString)) : links
      console.log(results)
      // call callback function to return suggestions
      cb(results)
    },
    createFilter(queryString) {
      return (link) => {
        return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    async getFiles() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      try {
        const { data } = await axios.post(`/api/v1/entityFiles/listOfArrTypeId?entityId=${this.form.id}`, { entityTypeIdArr: [76] })

        data.list.forEach(val => {
          if (val.entityTypeId === 76) {
            this.file = val
          }
        })

        console.log('list', data)
      } catch (err) {
        console.log(err)
      }
    },
    async handleFile(e) {
      await this.uploadFile(e.target.files[0], 76)
      this.$refs.fileVendor.value = null
      await this.getFiles()
    },
    async uploadFile(file, entityTypeId) {
      const loader = this.$loading.show()
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('convert', 'false')
        formData.append('entityId', this.form.id)
        formData.append('historyEntityId', '0')
        formData.append('taskId', 'null')
        formData.append('entityTypeId', entityTypeId)
        formData.append('oldParentId', null)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData)
        loader.hide()
        await this.getFiles()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async removeFile(file, entityTypeId) {
      const loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${file.id}&entityId=${this.$route.query.companyId}&historyEntityId=0&taskId=null&entityTypeId=${entityTypeId}&deleteChild=false`)
        this.file = null
        // await this.getFiles()
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async loadCountryList(val, row) {
      if (val) {
        row.countryList = await this.loadListBO('country', null, 'countryList')
      }
    },
    async changeCountry(row) {
      row.stateId = null
      row.cityId = null
      row.stateList = []
      row.cityList = []
      row.stateList = await this.loadListBO('state', row.countryId, 'stateList')
    },
    async changeState(row) {
      row.cityId = null
      row.cityList = []
      row.cityList = await this.loadListBO('city', row.stateId, 'cityList')
    },
    async loadListBO(type, id) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const response = await axios.get(`/api/v1/country/directories?type=${type}&id=${id}`)
      loader.hide()
      return response.data.list
    },
    openBranchOfficeTable() {
      this.$refs.modalBranchOfficeList.open()
    },
    addNewItem() {
      const itm = {
        TINCode: null,
        buId: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        countryId: null,
        stateId: null,
        cityId: null,
        postCode: null,
        rdoId: null,
        countryList: [],
        stateList: [],
        cityList: [],
      }

      this.form.branchOfficeList.push(itm)
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    modalBranchOfficeListSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid){
          this.$refs.modalBranchOfficeList.close()
        }
      })
    },
    closeModalBranchOfficeList() {
      let arrIndexForDelete = []
      this.form.branchOfficeList.forEach((el, index, arr) => {
        if (!el.buId || !el.rdoId) {
          arrIndexForDelete.push(index)
        }
      })
      this.deleteItemForArray(arrIndexForDelete.reverse())
    },
    deleteItemForArray(arr) {
      arr.forEach((el) => {
        this.form.branchOfficeList.splice(el, 1);
      })
    },
    changeCompanyTypeId() {
      this.form.productWithholdingTaxId = null
      this.form.taxCodeProduct = null
      this.form.serviceWithholdingTaxId = null
      this.form.taxCodeService = null

      this.form.applyWithholdingTax = false
    },
    openModal() {
      this.activeName = 'general'
      this.$refs['editVendorForm'].open()
    },
    setTaxCode(type, item) {
      if (type === 'taxCode') { item.tax ? (this.form.taxCode = item.tax.code) : null }
      if (type === 'taxCodeProduct') { item.tax ? (this.form.taxCodeProduct = item.tax.code) : null }
      if (type === 'taxCodeService') { item.tax ? (this.form.taxCodeService = item.tax.code) : null }
      if (type === 'taxCodeClientWithholding') { item.tax ? (this.form.taxCodeClientWithholding = item.tax.code) : null }
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['form'].resetFields();

      this.mainCountryList = []
      this.mainStateList = []
      this.mainCityList = []

      this.billingCountryList = []
      this.billingStateList = []
      this.billingCityList = []

      this.swCountryList = []
      this.swStateList = []
      this.swCityList = []

      this.bankCountryList = []
      this.bankStateList = []
      this.bankCityList = []

      this.file = null

      // Tax Settings
      this.form.companyTypeId = null
      this.form.saleTaxId = null
      this.form.taxCode = null
      this.form.clientWithholding = false
      this.form.clientWithholdingTaxId = null
      this.form.taxCodeClientWithholding = null
      this.form.applyWithholdingTax = true
      this.form.productWithholdingTaxId = null
      this.form.serviceWithholdingTaxId = null
      this.form.taxCodeProduct = null
      this.form.taxCodeService = null

      // Expanded
      this.form.registrationBodyId = 1
      // --General
      this.form.expandedCountryId = null
      this.form.industryTypeId = null
      this.form.categoryOfClientId = null
      this.form.companyName = null
      this.form.firstName = null
      this.form.middleName = null
      this.form.surname = null
      this.form.tradeName = null
      this.form.osca = null
      this.form.pwd = null
      this.form.rdoId = null
      this.form.barangay = null
      this.form.registrationSECNo = null
      // --Compliance
      this.form.taxClassificationId = null
      this.form.radio = 1
      this.form.lineOfBusinessId = null
      this.form.occupationId = null
      this.form.taxIdentificationNo = null
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Main Address
    loadMainCountryList(isVisiable) {
      if (isVisiable && this.mainCountryList.length < 2) {
        this.loadList('country', null, 'mainCountryList')
      }
    },
    loadMainStateList(isVisiable) {
      if (isVisiable && this.mainStateList.length < 2) {
        this.loadList('state', this.form.mainCountryId, 'mainStateList')
      }
    },
    loadMainCityList(isVisiable) {
      if (isVisiable && this.mainCityList.length < 2) {
        this.loadList('city', this.form.mainStateId, 'mainCityList')
      }
    },
    // Billing Address
    loadBillingCountryList(isVisiable) {
      if (isVisiable && this.billingCountryList.length < 2) {
        this.loadList('country', null, 'billingCountryList')
      }
    },
    loadBillingStateList(isVisiable) {
      if (isVisiable && this.billingStateList.length < 2) {
        this.loadList('state', this.form.billingCountryId, 'billingStateList')
      }
    },
    loadBillingCityList(isVisiable) {
      if (isVisiable && this.billingCityList.length < 2) {
        this.loadList('city', this.form.billingStateId, 'billingCityList')
      }
    },
    // Shipping/Warehouse Address
    loadSWCountryList(isVisiable) {
      if (isVisiable && this.swCountryList.length < 2) {
        this.loadList('country', null, 'swCountryList')
      }
    },
    loadSWStateList(isVisiable) {
      if (isVisiable && this.swStateList.length < 2) {
        this.loadList('state', this.form.swCountryId, 'swStateList')
      }
    },
    loadSWCityList(isVisiable) {
      if (isVisiable && this.swCityList.length < 2) {
        this.loadList('city', this.form.swStateId, 'swCityList')
      }
    },
    // Bank Address
    loadBankCountryList(isVisiable) {
      if (isVisiable && this.bankCountryList.length < 2) {
        this.loadList('country', null, 'bankCountryList')
      }
    },
    loadBankStateList(isVisiable) {
      if (isVisiable && this.bankStateList.length < 2) {
        this.loadList('state', this.form.bankCountryId, 'bankStateList')
      }
    },
    loadBankCityList(isVisiable) {
      if (isVisiable && this.bankCityList.length < 2) {
        this.loadList('city', this.form.bankStateId, 'bankCityList')
      }
    },
    setState(type) {
      if (type === 'main') {
        this.form.mainStateId = null
        this.form.mainCityId = null
        this.mainStateList = []
        this.mainCityList = []
      } else if (type === 'billing') {
        this.form.billingStateId = null
        this.form.billingCityId = null
        this.billingStateList = []
        this.billingCityList = []
      } else if (type === 'sw') {
        this.form.swStateId = null
        this.form.swCityId = null
        this.swStateList = []
        this.swCityList = []
      } else if (type === 'bank') {
        this.form.bankStateId = null
        this.form.bankCityId = null
        this.bankStateList = []
        this.bankCityList = []
      }
    },
    setCity(type) {
      if (type === 'main') {
        this.form.mainCityId = null
        this.mainCityList = []
      } else if (type === 'billing') {
        this.form.billingCityId = null;
        this.billingCityList = []
      } else if (type === 'sw') {
        this.form.swCityId = null;
        this.swCityList = []
      } else if (type === 'bank') {
        this.form.bankCityId = null;
        this.bankCityList = []
      }
    },
    submitForm(form) {
      this.$refs[form].validate((valid, object) => {
        if (valid) {

          const data = {
            enableExpanded: this.form.enableExpanded,
            // General
            name: this.form.name || this.value,
            shortName: this.form.shortName,
            email: this.form.email,
            website: this.linkFormatting(this.form.website),
            linkedIn: this.form.linkedIn,
            facebook: this.form.facebook,
            phone: this.form.phone,
            fax: this.form.fax,
            managerId: this.form.managerId,
            shippingMethodId: this.form.shippingMethodId,
            tagAs: this.form.tagAs,

            // Address
            addresses: {
              mainAddress: {
                countryId: this.form.mainCountryId,
                stateId: this.form.mainStateId,
                cityId: this.form.mainCityId,
                postCode: this.form.mainPostCode,
                addressLines: {
                  addressLine1: this.form.mainAddress,
                  addressLine2: this.form.mainAddress2,
                  addressLine3: this.form.mainAddress3
                }
              },
              billingAddress: {
                copyMainAddress: this.form.billingCopyMainAddress,
                countryId: this.form.billingCopyMainAddress ? this.form.mainCountryId : this.form.billingCountryId,
                stateId: this.form.billingCopyMainAddress ? this.form.mainStateId : this.form.billingStateId,
                cityId: this.form.billingCopyMainAddress ? this.form.mainCityId : this.form.billingCityId,
                postCode: this.form.billingCopyMainAddress ? this.form.mainPostCode : this.form.billingPostCode,
                addressLines: {
                  addressLine1: this.form.billingCopyMainAddress ? this.form.mainAddress : this.form.billingAddress,
                  addressLine2: this.form.billingCopyMainAddress ? this.form.mainAddress2 : this.form.billingAddress2,
                  addressLine3: this.form.billingCopyMainAddress ? this.form.mainAddress3 : this.form.billingAddress3
                }
              },
              shippingWarehouseAddress: {
                copyMainAddress: this.form.swCopyMainAddress,
                countryId: this.form.swCopyMainAddress ? this.form.mainCountryId : this.form.swCountryId,
                stateId: this.form.swCopyMainAddress ? this.form.mainStateId : this.form.swStateId,
                cityId: this.form.swCopyMainAddress ? this.form.mainCityId : this.form.swCityId,
                postCode: this.form.swCopyMainAddress ? this.form.mainPostCode : this.form.swPostCode,
                addressLines: {
                  addressLine1: this.form.swCopyMainAddress ? this.form.mainAddress : this.form.swAddress,
                  addressLine2: this.form.swCopyMainAddress ? this.form.mainAddress2 : this.form.swAddress2,
                  addressLine3: this.form.swCopyMainAddress ? this.form.mainAddress3 : this.form.swAddress3
                }
              },
              bankAddress: null,
              branchOfficeList: this.form.branchOfficeList ? this.form.branchOfficeList.map(val => ({
                cityId: val.cityId,
                stateId: val.stateId,
                countryId: val.countryId,
                rdoId: val.rdoId,
                buId: val.buId,
                TINCode: val.TINCode,
                addressLine1: val.addressLine1,
                addressLine2: val.addressLine2,
                addressLine3: val.addressLine3,
                postCode: val.postCode
              })) : [],
            },

            // Finance
            finance:{
              currencyId: this.form.currencyId,
              creditLimit: this.form.creditLimit,
              paymentTermsId: this.form.paymentTermsId,
              paymentTypesId: this.form.paymentTypesId,
              bankName: this.form.bankName,
              bankAddressAssign: this.form.bankAddressAssign,
              SWIFTCode: this.form.SWIFTCode,
              accountName: this.form.accountName,
              branchSortCode: this.form.branchSortCode,
              accountIBANNo: this.form.accountIBANNo,
              outstanding: null
            },

            // Canvass
            canvas:{
              ISOAccreditationNo: this.form.ISOAccreditationNo,
              canvassSheetId: this.form.canvassSheetId,
              formsId: this.form.formsId
            },

            // Custom
            customFields:{
              customField1: this.form.customField1,
              customField2: this.form.customField2,
              customField3: this.form.customField3,
              customField4: this.form.customField4,
              customField5: this.form.customField5,
              customField6: this.form.customField6
            },

            // Tax Settings
            tax: {
              companyTypeId: this.form.companyTypeId,
              saleTaxId: this.form.saleTaxId,
              clientWithholding: this.form.clientWithholding,
              clientWithholdingTaxId: this.form.clientWithholding ? this.form.clientWithholdingTaxId : null,
              productWithholdingTaxId: this.form.productWithholdingTaxId,
              serviceWithholdingTaxId: this.form.serviceWithholdingTaxId
            }
          }

          // Expanded
          if (this.form.enableExpanded) {
            let obj = {
              registrationBodyId: this.form.registrationBodyId,
              general: {
                countryId: this.form.expandedCountryId,
                industryTypeId: this.form.industryTypeId,
                categoryOfClientId: this.form.categoryOfClientId,
                companyName: this.form.registrationBodyId !== 1 ? this.form.companyName : null,
                firstName: this.form.registrationBodyId === 1 ? this.form.firstName : null,
                middleName: this.form.registrationBodyId === 1 ? this.form.middleName : null,
                surname: this.form.registrationBodyId === 1 ? this.form.surname : null,
                tradeName: this.form.tradeName,
                osca: this.form.registrationBodyId === 1 ? this.form.osca : null,
                pwd: this.form.registrationBodyId === 1 ? this.form.pwd : null,
                rdoId: this.form.rdoId,
                barangay: this.form.barangay,
                registrationSECNo: this.form.registrationSECNo,
              },
              compliance: {
                taxClassificationId: this.form.taxClassificationId,
                lineOfBusinessId: this.form.radio === 1 ? this.form.lineOfBusinessId : null,
                occupationId: this.form.radio === 2 ? this.form.occupationId : null,
                taxIdentificationNo: this.form.taxIdentificationNo
              }
            }
            data.expanded = obj
          }

          if (this.form.bankAddressAssign) {
            let obj = {
              countryId: this.form.bankCountryId,
              stateId: this.form.bankStateId,
              cityId: this.form.bankCityId,
              postCode: this.form.bankPostCode,
              addressLines: {
                addressLine1: this.form.bankAddress,
                addressLine2: this.form.bankAddress2,
                addressLine3: this.form.bankAddress3
              }
            }
            data.addresses.bankAddress = obj
          } else {
            data.addresses.bankAddress = null
          }

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/client-vendor/update?companyId=${this.$route.query.companyId}&entityType=vendor&id=${this.form.id}`, data)
            .then(response => {
              console.log('---/companyVendors/update', response.data);
              this.$store.dispatch('getRowDataVendors')
              this.$refs.editVendorForm.close();
              this.notification("Success", "Update Vendor", "success");
              this.$emit('selected')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            })

        } else {
          if (object.name || object.shortName || object.email) {
              this.activeName = 'general'
            } else if (object.mainCountryId || object.mainStateId || object.mainCityId) {
              this.activeName = 'addresses'
            } else if (object.bankCountryId || object.bankStateId || object.bankCityId) {
              this.activeName = 'finance'
            } else if (object.currencyId) {
              this.activeName = 'finance'
            } else if (object.taxClassificationId || object.lineOfBusinessId || object.occupationId || object.taxIdentificationNo) {
              this.activeName = 'expanded'
            } else if (object.companyTypeId || object.saleTaxId || object.clientWithholdingTaxId || object.productWithholdingTaxId || object.serviceWithholdingTaxId) {
              this.activeName = 'settings'
            }
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.sweet-modal-overlay{
  z-index:1000;
}
.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__file-name {
    max-width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}

/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>
